<template>
  <div class="content">
    <div class="gift-swiper">
      <van-swipe class="my-swipe">
        <van-swipe-item v-for="(item, index) in giftList" :key="index">
          <van-grid>
            <van-grid-item :class="active === li.id ? 'active' : ''" @click="selectGift(li.id)" v-for="li in item" :key="li.id">
              <van-image :src="li.img" />
              <h4>{{ li.title }}</h4>
              <p>{{ li.total }}积分</p>
            </van-grid-item>
          </van-grid>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="handle">
      <van-button round class="an-but total-but">
        积分：
        <b>{{ total }}</b>
        <i class="iconfont icon-more1"></i>
      </van-button>
      <van-button round class="an-but save-but">发送</van-button>
    </div>
  </div>
</template>
<script>
const giftList = [];
export default {
  data() {
    return {
      total: 2455,
      giftList,
      active: null
    };
  },
  created() {
    this.giftList = this.group(this.giftList, 8);
  },
  methods: {
    selectGift(id) {
      this.active = id;
    },
    group(arr, cutLength) {
      let i = 0;
      let result = [];
      while (i < arr.length) {
        result.push(arr.slice(i, (i += cutLength)));
      }
      return result;
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  padding: 20px 16px;
  .gift-swiper {
    .my-swipe {
      padding-bottom: 32px;
    }
    /deep/.van-swipe-item {
      text-align: center;
      .van-grid-item {
        .van-grid-item__content {
          padding: 8px;
        }
        &.active {
          .van-grid-item__content {
            border-radius: 8px;
            background: #f4f4f4;
          }
        }
      }
      .van-image {
        width: 50px;
      }
      h4 {
        font-size: 13px;
        margin-top: 6px;
      }
      p {
        font-size: 10px;
        color: #ccc;
      }
      .van-grid-item__content::after {
        border: none;
      }
    }
  }
  .handle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .an-but {
      height: 36px;
      line-height: 36px;
    }
    .total-but {
      padding: 0 8px 0 12px;
      b {
        color: #f34444;
      }
      i {
        display: inline-block;
        margin-left: 12px;
        color: #ccc;
      }
    }
    .save-but {
      padding: 0 24px;
      border: none;
      background: linear-gradient(90deg, rgba(243, 68, 68, 1) 0%, rgba(255, 131, 101, 1) 100%);
      span {
        color: #fff;
      }
    }
  }
}
</style>
